import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    search: undefined,
  },
  isOpenModal: false,
}

export const eventApprovalSlice = createAppSlice({
  name: 'eventApproval',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModalApproval: create.reducer((state, { payload }) => {
      state.isOpenModal = !state.isOpenModal
    }),
  }),
  extraReducers: (builder) => {},
})

export const { setFetchOption, toggleModalApproval } =
  eventApprovalSlice.actions

export default eventApprovalSlice.reducer
